import ListSection from "./ListSection";
import { MdTranslate } from "react-icons/md";
import styles from "./PhrasesSection.module.scss";
import SectionTitle from "./SectionTitle";

export default function PhrasesSection({ phrases }) {
  const entries = Object.entries(phrases)
    .slice(1, Object.entries(phrases).length)
    .filter((entry) => entry[0] !== "language");

  const phraseElements = entries.map((entry, index) => {
    return (
      <Phrase name={entry[0]} phrase={entry[1]} key={`${entry[0]}-index}`} />
    );
  });

  return (
    <>
      <SectionTitle title="Useful Phrases" icon={<MdTranslate size={34} />} />
      {phrases?.language && (
        <div className={`${styles.language}`}>
          <span>
            <b>Language: </b>
          </span>
          <span>{phrases.language}</span>
        </div>
      )}
      <ListSection
        id="useful-phrases"
        itemType="component"
        items={phraseElements}
        listStyle="none"
      />
    </>
  );
}

function Phrase({ name, phrase }) {
  if (!phrase) return null;

  const { transliterated, native, pronunciation } = phrase;

  return (
    <article className={`${styles.phrase}`}>
      <div className={`${styles.name}`}>{name.replace("_", " ")}</div>
      <div className={`${styles.translation}`}>
        <span className={`${styles.native}`}>{native}</span>
        <span className={`${styles.pronunciation}`}> ({pronunciation}) </span>
      </div>
    </article>
  );
}
